module.exports = __webpack_public_path__ + "media/landing_page/person-icon-c05d0603.svg";